module.exports = __webpack_public_path__ + "img/home-img-1.7796c253.png";